import { render, staticRenderFns } from "./resourceCard.vue?vue&type=template&id=7f24983f&"
import script from "./resourceCard.vue?vue&type=script&lang=js&"
export * from "./resourceCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports